import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * 통합 로그 API
 */
export default {
  /**
   * [통합로그 > 프레임] 필터 트리를 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogFilterTree() {
    return axios.get(`${baseUrl}/log/config/get-log-filter-tree.do`);
  },
  /**
   * [통합로그 > 프레임] 인덱스(저장소) 트리를 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogIndexTree() {
    return axios.get(`${baseUrl}/log/config/get-log-index-tree.do`);
  },
  /**
   * [통합로그 > 필터] 모든 필터 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getAllFilters() {
    return axios.get(`${baseUrl}/integrated-log/filter/get-all-filters.do`);
  },
  /**
   * [통합로그 > 필터 편집 팝업] 필터 그룹 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogFilterGroups() {
    return axios.get(`${baseUrl}/integrated-log/filter/get-log-filter-groups.do`);
  },
  /**
   * [통합로그 > 필터 편집 팝업] 필터 그룹에 속한 필터 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [filterGroupId]
   * @return {[type]}        [description]
   */
  getLogFiltersByGroup(params) {
    return axios.get(`${baseUrl}/integrated-log/filter/get-log-filters-by-group.do`, params);
  },
  /**
   * [통합로그 > 공통 필드] 로그의 공통 필드 목록을 조회해온다.(default)
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogDefaultFields() {
    return axios.get(`${baseUrl}/log/config/get-log-default-fields.do`);
  },
  /**
   * [통합로그 > 모든 필드] 로그의 모든 필드 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogAllFields() {
    return axios.get(`${baseUrl}/log/config/get-log-all-fields.do`);
  },
  /**
   * [통합로그 > 인덱스 필드] 인덱스 ID로 필드 정보를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [트리에서 선택된 저장소 트리 노드의 dataindexId]
   * @return {[type]}        [description]
   */
  getLogFieldsByIndex(params) {
    return axios.get(`${baseUrl}/log/config/get-log-fields-by-index.do`, params);
  },
  /**
   * [통합로그 > Show필드] Show_flag가 Y인 필드 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogShowFields() {
    return axios.get(`${baseUrl}/log/config/get-log-show-fields.do`);
  },
  /**
   * [통합로그 > 필터 필드] 필터별 필드 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [customFilterId]
   * @return {[type]}        [description]
   */
  getLogFieldsByCustomFilter(params) {
    return axios.get(`${baseUrl}/log/config/get-log-fields-by-custom-filter.do`, params);
  },
  /**
   * [통합로그 > 대시보드] 키워드맵 설정용 필드 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getKeywordMapSearchFields(params) {
    return axios.get(`${baseUrl}/log/config/get-keyword-map-search-fields.do`, {
      params,
    });
  },
  /**
   * [통합로그 > 필터] 필터를 추가한다.
   * @author Minyeong
   * @param  {[type]} params [추가할 필터의 정보]
   * @return {[type]}        [description]
   */
  insertFilter(querystring, payload) {
    return axios.post(`${baseUrl}/integrated-log/filter/insert-filter.do?${querystring}`, payload);
  },
  /**
   * [통합로그 > 필터] 필터를 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteFilter(params) {
    return axios.post(`${baseUrl}/integrated-log/filter/delete-filter.do`, params);
  },
  /**
   * [통합로그 > 필터] 필터를 수정한다.
   * @author Minyeong
   * @param  {[type]} querystring [description]
   * @param  {[type]} payload     [description]
   * @return {[type]}             [description]
   */
  updateFilter(querystring, payload) {
    return axios.post(`${baseUrl}/integrated-log/filter/update-filter.do?${querystring}`, payload);
  },
  /**
   * [통합로그 > 필터] filterId로 단일 필터 정보를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [filterId]
   * @return {[type]}        [description]
   */
  getLogFilterByKey(params) {
    return axios.get(`${baseUrl}/integrated-log/filter/get-log-filter-by-key.do`, params);
  },
  /**
   * [통합로그 > 필터] 필터그룹 내 필터의 최대 순서값을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getMaxOrderbyIndex(params) {
    return axios.get(`${baseUrl}/integrated-log/filter/get-max-orderby-index.do`, params);
  },
  /**
   * [통합로그 > 필터 편집 팝업] 저장소(인덱스) 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getIndexList() {
    return axios.get(`${baseUrl}/integrated-log/analysis/get-index-list.do`);
  },
  /**
   * [통합로그 > 저장소] use_flag가 Y인 저장소 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getUsingIndexList() {
    return axios.get(`${baseUrl}/integrated-log/analysis/get-using-index-list.do`);
  },
  /**
   * [통합로그 > 필터그룹] 필터 그룹을 추가한다.
   * @author Minyeong
   * @param  {[type]} params [추가할 필터 그룹 정보]
   * @return {[type]}        [description]
   */
  insertFilterGroup(params) {
    return axios.post(`${baseUrl}/integrated-log/filter/insert-filter-group.do`, params);
  },
  /**
   * [통합로그 > 필터그룹] 필터 그룹을 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [삭제할 필터 그룹 정보 목록]
   * @return {[type]}        [description]
   */
  deleteFilterGroup(params) {
    return axios.post(`${baseUrl}/integrated-log/filter/delete-filter-group.do`, params);
  },
  /**
   * [통합로그 > 필터그룹] 필터 그룹을 수정한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateFilterGroup(params) {
    return axios.post(`${baseUrl}/integrated-log/filter/update-filter-group.do`, params);
  },
  /**
   * [통합로그 > 필터그룹] 필터 그룹의 순서를 수정한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateFilterGroupOrder(params) {
    return axios.post(`${baseUrl}/integrated-log/filter/update-filter-group-order.do`, params);
  },
  /**
   * [통합로그 > 필터] 필터의 순서를 수정한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateFilterOrder(params) {
    return axios.post(`${baseUrl}/integrated-log/filter/update-filter-order.do`, params);
  },
  /**
   * [통합로그 > 실시간] 검색 조건으로 로그 데이터를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getLogDatas(params) {
    return axios.post(`${baseUrl}/integrated-log/analysis/get-log-datas.do`, params);
  },
  /**
   * [통합로그 > 실시간 > 상세정보 팝업] 로그 이력 차트 데이터를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [logType, objId, startDateTime, endDateTime]
   * @return {[type]}        [description]
   */
  getLogHistChartData(params) {
    return axios.post(`${baseUrl}/integrated-log/analysis/get-log-hist-chart-data.do`, params);
  },
  /**
   * [통합로그 > 대시보드] 로그 이력 히스토그램 위젯 차트 데이터를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getMultiIndexChartData(params) {
    return axios.post(`${baseUrl}/integrated-log/analysis/get-multi-index-chart-data.do`, params);
  },
  /**
   * [통합로그 > 분석] 로그 히스토그램 차트 데이터를 조회해온다.
   * @author Minyeong
   * @param  {[type]}  params [description]
   * @return {Boolean}        [description]
   */
  getAnalysisHistogramData(params) {
    return axios.post(`${baseUrl}/integrated-log/analysis/get-analysis-histogram-data.do`, params);
  },
  /**
   * [통합로그 > 분석] 로그 데이터를 엑셀 파일로 생성해 출력한다.
   * @author Minyeong
   * @param  {[type]}  params [description]
   * @return {Boolean}        [description]
   */
  getLogAnalysisExcelName(params) {
    return axios.post(`${baseUrl}/integrated-log/analysis/get-log-analysis-excel-name.do`, params);
  },
  /**
   * [통합로그 > 분석 > 베이스라인] 단일 필터의 베이스라인 정보(stats_period, upper_bound, lower_bound)를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getBaselineInfo(params) {
    return axios.get(`${baseUrl}/integrated-log/analysis/get-baseline-info.do`, params);
  },
  /**
   * [통합로그 > 분석 > 베이스라인] 단일 필터의 베이스라인 차트 데이터를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getBaselineChartData(params) {
    return axios.post(`${baseUrl}/integrated-log/analysis/get-baseline-chart-data.do`, params);
  },
  /**
   * [통합로그 > 상세정보 팝업] 이름이 등록된 머신러닝 패턴 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getMlPatternWithName() {
    return axios.get(`${baseUrl}/integrated-log/analysis/get-ml-pattern-with-name.do`);
  },
  /**
   * [통합로그 > 키워드맵] 키워드 맵 데이터 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getWordChart(params) {
    return axios.post(`${baseUrl}/integrated-log/analysis/get-word-chart.do`, params);
  },
  /**
   * [통합로그 > 알람] 로그 알람 발생 이력 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogEventHists(params) {
    return axios.post(`${baseUrl}/integrated-log/event/get-log-event-hists.do`, params);
  },
  /**
   * [통합로그 > 알람] 머신러닝 패턴 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getMlPatterns() {
    return axios.get(`${baseUrl}/integrated-log/event/get-ml-patterns.do`);
  },
  /**
   * [통합로그 > 알람] 단일 알람 이력의 처리 이력(코멘트) 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [event_seq (알람 이력의 primary key)]
   * @return {[type]}        [description]
   */
  getEventComments(params) {
    return axios.get(`${baseUrl}/integrated-log/event/get-event-comments.do`, params);
  },
  /**
   * [통합로그 > 알람] 알람 이력의 처리 이력(코멘트)를 추가한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertEventComment(params) {
    return axios.post(`${baseUrl}/integrated-log/event/insert-event-comment.do`, params);
  },
  /**
   * [통합로그 > 알람] 알람 이력의 처리 이력(코멘트)를 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteEventComment(params) {
    return axios.post(`${baseUrl}/integrated-log/event/delete-event-comment.do`, params);
  },
  /**
   * [통합로그 > 알람] 알람 이력 목록을 엑셀 파일로 생성한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  createLogEventExcel(params) {
    return axios.post(`${baseUrl}/integrated-log/event/create-log-event-excel.do`, params);
  },
  /**
   * [통합로그 > 대시보드 위젯 설정] 이벤트 종류 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getEventTypes() {
    return axios.get(`${baseUrl}/integrated-log/event/get-event-types.do`);
  },
  /**
   * 로그 메시지 구성 차트 데이터 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getLogMessageChartData(params) {
    return axios.post(`${baseUrl}/integrated-log/analysis/get-log-message-chart-data.do`, params);
  },
  /**
   * 키워드맵 그룹 필드 데이터 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getGroupField(params) {
    return axios.post(`${baseUrl}/integrated-log/analysis/get-group-field.do`, params);
  },
  /**
   * 로그 상세 화면에서 SUBOID를 조회한다.
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getSubOIDList(params) {
    return axios.post(`${baseUrl}/integrated-log/analysis/get-sub-oid-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/log/integrated-log.js